import { createFileRoute } from "@tanstack/react-router";
import { ContractProducerComparisonPage } from "@/features/contracts/contract-producer-comparison-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/porownanie-z-producentem")({
	component: ContractProducerComparisonPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.porownanie-z-producentem",
			location.pathname,
		);
	},
});
